import { uniqueNamesGenerator, adjectives, colors } from 'unique-names-generator';


export class Random {
    private seed: number;
    private stringSeed: string | null;
    private m: number = 0x80000000; // 2^31
    private a: number = 1103515245;
    private c: number = 12345;
    public savedGame: boolean = false;
    public savedGameFile: unknown | null = null;

    constructor(seedInput: string | number | null) {
        this.stringSeed = null;

        if (seedInput == null) {

            const randomName = uniqueNamesGenerator({
                dictionaries: [adjectives, colors], // You can customize dictionaries here
                separator: '-',
                length: 2 // This ensures only two words are generated
            });

            this.seed = this.seedFromString(randomName);
            this.stringSeed = randomName;

        } else if (typeof seedInput === 'string') {

            seedInput = seedInput.toLocaleLowerCase();

            this.seed = this.seedFromString(seedInput);
            this.stringSeed = seedInput;
        } else {
            this.seed = Math.floor(Math.abs(seedInput)) % this.m || 1;
        }
    }

    private next(): number {
        this.seed = (this.a * this.seed + this.c) % this.m;
        return this.seed / this.m;
    }

    public random(): number {
        return this.next();
    }

    private hashString(str: string): number {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char; // hash * 31 + char, assuming 31 can be replaced with a bit-shift and subtract
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }

    private seedFromString(seedInput: string): number {
        return (this.hashString(seedInput) >>> 0) % this.m || 1;
    }

    public getCurrentSeed(): string {
        if (this.stringSeed != null) {
            return this.stringSeed;
        } else {
            return this.seed.toString();
        }

    }
}
